module.exports = __webpack_public_path__ + "img/default_admin.7823e4bd.png";